import { render } from "./AssetExportControls.vue?vue&type=template&id=82ed4b0e"
import script from "./AssetExportControls.vue?vue&type=script&lang=js"
export * from "./AssetExportControls.vue?vue&type=script&lang=js"
script.render = render

export default script